<!-- MFITTで購入期限を過ぎて座席指定に進もうとした場合 -->
<template>
  <ItemDialog ref="canNotGoToSheetMapByPurchaseLimit" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        シートマップによる座席指定ができるのは発車3分前までです。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotGoToSheetMapByPurchaseLimit",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const canNotGoToSheetMapByPurchaseLimit = ref(null);

    const openDialog = () => {
      canNotGoToSheetMapByPurchaseLimit.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        canNotGoToSheetMapByPurchaseLimit.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      canNotGoToSheetMapByPurchaseLimit,
      openDialog,
      closeDialog,
    };
  },
};
</script>
